<template>
  <div class="data-conent">
    <div class="top_item">
      <div class="left">
        <div class="title">
          <span :key="index" v-for="(i,index) in changTitleSHOW(data.title)">{{i}}</span>
          </div>
     
        <div class="author item">{{ data.author }}</div>
      </div>
      <div class="right">
        <div :class="'row row'+index " v-for="(item,index) in changeArray(data.content)" :key="item">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="bottom_item">
      <div class="time">
       <span>-</span> <span>{{ data.date}}</span>
        <span class="week">{{ data.week}} </span>
          <span>-</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return ""
      },
    },
  },
  data(){
    return{
       str:"胖娃儿胖嘟嘟，\\骑马上成都。\\成都又好耍，\\胖娃儿骑白马。\\白马跳得高，\\胖娃儿耍关刀。\\关刀耍得圆，\\胖娃儿滚铜元。\\铜元滚得远，\\胖娃儿跟倒撵。\\撵又撵不上，\\白白跑一趟。"
    }
  },
  computed: {
    changeArray: function() {
      return function(value) {
        // console.log("value==",value)
         let array1 =[]
          if(value!==undefined){
              array1 = value.split("\\");
          }
      

        return array1;
      };
    },
    changTitleSHOW:function(){
      return function(value){
        let list=[]
        // console.log("value!==undefined===",value!==undefined)
        if(value!==undefined){
          if(value.length>10){
                    list.push(value.substr(0,10))
                    list.push(value.substr(9,(value.length-10)))
                  }else if(value.length>20){
                    list.push(value.substr(0,10))
                    list.push(value.substr(9,(value.length-10)))
                      list.push(value.substr(0,10))
                    list.push(value.substr(19,(value.length-10)))
                  }else{
                    // 小于10
                    list.push(value)
                  }
        }
        // console.log("value==",value)
       
        return list
        
      }
    }
  },
};
</script>
<style lang="less" scoped>
.data-conent {
  position: relative;
    display: flex;
    flex-direction: column;
    padding-top:0.346667rem;
  .top_item {
    width: 100%;
    max-height:9.9rem;
    position: relative;
    // display: flex;
    // justify-content: space-between;
  height: 100%;
    //  margin-bottom: 0.5rem;
    .left {
      width: 100%;
     
      .title {
        width: 100%;
        font-size:.426667rem;
        color: rgba(18, 18, 18, 1);
        font-weight: 600;
        margin-bottom: .48rem;
      display: flex;
      justify-content: center;
        span{
          margin: 0 0.02rem;
        }
      }
      .item {
        width: 100%;
        font-size: 0.32rem;
        color: rgba(117, 117, 117, 1);
        
    text-align: center;
      }
      .author {
        margin-top: .16rem;
        color: #757575;
      }
     
    }
    .right {
      height: 100%;
      overflow: auto;
      // margin-top: 1.313333rem;
          padding-top: 0.6rem;
      width:100%;
      font-size: 0.373333rem;
      color:#191919 ;
      .row {
        margin: 0.186667rem auto;
        text-align: center;
      }
      .row0{
        margin-top: 0;
      }
    }
  }
  .bottom_item {
     
       position: relative;
    left: 0;
    right: 0;
    font-size: 0.32rem;
    width: 4rem;
    margin: 0 auto;
    text-align: center;
        margin-top: 0.6rem;
    .time {
      color: #A3A3A3;
      .week{
        margin-left: 0.093333rem;
      }
     
    }
  }
}
</style>
